<template>
    <div class="footer">
        <!-- <p @click="theme('111')">theme1</p>
        <p @click="theme('113')">theme2</p>
         -->
        <div>
            <p>{{ info.supplier }}授权给{{ info.customer }}&nbsp;&nbsp;<span v-if="online">{{ info.duration }}&nbsp;&nbsp;{{ info.chapters }}</span></p>
        </div>
    </div>
</template>

<script>

export default {
    
    data() {
        return {
            info: {},
        }
    },
    computed: {
        online() {
            return this.$store.state.online
        }
    },
    mounted() {
        let that = this;
        that.bottomInfo();
    },
    methods: {
        bottomInfo() {
            let that = this;
            that.allApi.bottomInfo().then((resource) => {
                if( resource.data.code == 200 ) {
                    that.info = resource.data.data;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .footer{
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        @include footer_bg_color(#1AA7E0);
        text-align: center;
        font-size: 20px;
        @include dominant_color(#1c1c1c);
        line-height: 26px;
        padding: 30px 0 84px;
    }
</style>
